import { useState } from 'react';
import { CaptionButton } from '~/shared/components/ui/Button';
import {
  PreviewGenerateHistoryDialog,
  PreviewGenerateInputOption,
  PreviewGenerateHistoryItem,
} from '~/shared/components/ui/Dialog/PreviewGenerateHistoryDialog';
import { convertDateToLong } from '~/shared/utils';

export const UISamplePreviewGenerateHistoryDialogs = () => {
  const [confirmationResult, setConfirmationResult] = useState('');
  const [isConfirmationShow, setConfirmationShow] = useState(false);

  const inputOption: PreviewGenerateInputOption = {
    isPublic: true,
    generateResults: [
      {
        updateDate: convertDateToLong(new Date()),
        prompt: 'ステンレス加工の加工精度が強みなのでアピールしたい-2',
        companyOverview:
          '企業紹介-2\n0.05mmからの極薄ステンレス溶接に特化。熱歪みを極限まで抑える微細加工技術。\n創業以来、ステンレスの精密板金加工に注力。特に熱影響の少ないYAGレーザー溶接機を駆使し、従来は困難とされていたt0.1mm以下の薄板でも、歪みや焦げのない美しい仕上がりを実現します。\n半導体製造装置や医療機器など、高精度が求められる分野での気密溶接実績が豊富です。\n詳細を出すための技術を書いています。',
        evaluationIndex1:
          '評価指標1-2\n金型レス板金による短納期対応可。量産プレスは不可。',
        evaluationIndex2:
          '評価指標2-2\n3次元測定機による平面度・幾何公差のデータ添付可能。',
        evaluationIndex3:
          '評価指標3-2\n半導体・医療・食品機械\nクリーン度や外観品質（キズ不可）が厳しい業界で8割。',
        evaluationIndex4:
          '評価指標4-2\n3次元測定機による平面度・幾何公差のデータ添付可能。',
      },
      {
        updateDate: convertDateToLong(new Date()),
        prompt: 'ステンレス加工の加工精度が強みなのでアピールしたい-3',
        companyOverview:
          '企業紹介-3\n0.05mmからの極薄ステンレス溶接に特化。熱歪みを極限まで抑える微細加工技術。\n創業以来、ステンレスの精密板金加工に注力。特に熱影響の少ないYAGレーザー溶接機を駆使し、従来は困難とされていたt0.1mm以下の薄板でも、歪みや焦げのない美しい仕上がりを実現します。\n半導体製造装置や医療機器など、高精度が求められる分野での気密溶接実績が豊富です。\n詳細を出すための技術を書いています。',
        evaluationIndex1:
          '評価指標1-3\n金型レス板金による短納期対応可。量産プレスは不可。',
        evaluationIndex2:
          '評価指標2-3\n3次元測定機による平面度・幾何公差のデータ添付可能。',
        evaluationIndex3:
          '評価指標3-3\n半導体・医療・食品機械\nクリーン度や外観品質（キズ不可）が厳しい業界で8割。',
        evaluationIndex4:
          '評価指標4-3\n3次元測定機による平面度・幾何公差のデータ添付可能。',
      },
    ],
    publishedInfo: {
      updateDate: convertDateToLong(new Date()),
      prompt: 'ステンレス加工の加工精度が強みなのでアピールしたい-2',
      companyOverview:
        '企業紹介-2\n0.05mmからの極薄ステンレス溶接に特化。熱歪みを極限まで抑える微細加工技術。\n創業以来、ステンレスの精密板金加工に注力。特に熱影響の少ないYAGレーザー溶接機を駆使し、従来は困難とされていたt0.1mm以下の薄板でも、歪みや焦げのない美しい仕上がりを実現します。\n半導体製造装置や医療機器など、高精度が求められる分野での気密溶接実績が豊富です。\n詳細を出すための技術を書いています。',
      evaluationIndex1:
        '評価指標1-2\n金型レス板金による短納期対応可。量産プレスは不可。',
      evaluationIndex2:
        '評価指標2-2\n3次元測定機による平面度・幾何公差のデータ添付可能。',
    },
    defaultSample: {
      updateDate: convertDateToLong(new Date()),
      prompt: 'ステンレス加工の加工精度が強みなのでアピールしたい-2',
      companyOverview:
        '企業紹介-2\n0.05mmからの極薄ステンレス溶接に特化。熱歪みを極限まで抑える微細加工技術。\n創業以来、ステンレスの精密板金加工に注力。特に熱影響の少ないYAGレーザー溶接機を駆使し、従来は困難とされていたt0.1mm以下の薄板でも、歪みや焦げのない美しい仕上がりを実現します。\n半導体製造装置や医療機器など、高精度が求められる分野での気密溶接実績が豊富です。\n詳細を出すための技術を書いています。',
      evaluationIndex1:
        '評価指標1-2\n金型レス板金による短納期対応可。量産プレスは不可。',
      evaluationIndex2:
        '評価指標2-2\n3次元測定機による平面度・幾何公差のデータ添付可能。',
    },
    tempSave: {
      updateDate: convertDateToLong(new Date()),
      prompt: 'ステンレス加工の加工精度が強みなのでアピールしたい-2',
      companyOverview:
        '企業紹介-2\n0.05mmからの極薄ステンレス溶接に特化。熱歪みを極限まで抑える微細加工技術。\n創業以来、ステンレスの精密板金加工に注力。特に熱影響の少ないYAGレーザー溶接機を駆使し、従来は困難とされていたt0.1mm以下の薄板でも、歪みや焦げのない美しい仕上がりを実現します。\n半導体製造装置や医療機器など、高精度が求められる分野での気密溶接実績が豊富です。\n詳細を出すための技術を書いています。',
      evaluationIndex1:
        '評価指標1-2\n金型レス板金による短納期対応可。量産プレスは不可。',
      evaluationIndex2:
        '評価指標2-2\n3次元測定機による平面度・幾何公差のデータ添付可能。',
    },
  };

  return (
    <div className="categories">
      <h3 id="dialog">生成履歴ダイアログ</h3>

      <div className="input-line">
        <div className="item-group-100">
          <div className="w-33">
            <CaptionButton
              buttonType="basic"
              caption="確認する"
              name=""
              onClick={() => {
                setConfirmationResult('');
                setConfirmationShow(true);
              }}
            />
            <PreviewGenerateHistoryDialog
              isOpen={isConfirmationShow}
              inputOption={inputOption}
              onDecision={(v: PreviewGenerateHistoryItem) => {
                setConfirmationResult(v.companyOverview ?? '');
                setConfirmationShow(false);
              }}
              onCancel={() => {
                setConfirmationResult('キャンセルしました');
                setConfirmationShow(false);
              }}
            />
          </div>
          <div className="w-66">
            <pre className="output">{confirmationResult}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};
